import { render, staticRenderFns } from "./boost-button.vue?vue&type=template&id=5119be8f&scoped=true&"
import script from "./boost-button.vue?vue&type=script&lang=js&"
export * from "./boost-button.vue?vue&type=script&lang=js&"
import style0 from "./boost-button.vue?vue&type=style&index=0&id=5119be8f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5119be8f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
